import { render } from "./VideoPlayerMedia.vue?vue&type=template&id=2a319ffc&scoped=true"
import script from "./VideoPlayerMedia.vue?vue&type=script&lang=js"
export * from "./VideoPlayerMedia.vue?vue&type=script&lang=js"

import "./VideoPlayerMedia.vue?vue&type=style&index=0&id=2a319ffc&scoped=true&lang=css"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a319ffc"]])

export default __exports__